import React from "react";
import StaticContentPage from "../components/StaticContentPage";

export default function Terms() {
  return (
    <StaticContentPage
      title="Terms of Use | CryptoBag"
      description="Review the CryptoBag terms of use for informational content, editorial material, external links, and limits on platform responsibility."
      canonical="https://cryptobag.net/terms"
      eyebrow="Terms"
      heading="Terms of Use"
      intro="CryptoBag is intended as an informational platform for market awareness, crypto education, and original content. It is not a trading venue, custody service, or substitute for professional financial, legal, or tax advice."
      sections={[
        {
          title: "Informational Use Only",
          paragraphs: [
            "CryptoBag provides market information, commentary, news references, and related crypto content for general informational purposes only. Nothing on the site should be interpreted as personalized financial, legal, tax, or investment advice.",
          ],
        },
        {
          title: "Availability And Accuracy",
          paragraphs: [
            "CryptoBag depends on third-party data sources, linked content, and networked services, which means some information may occasionally be delayed, incomplete, unavailable, or inconsistent with other public sources. The site is provided on an as-available basis, with no guarantee of uninterrupted access or perfect accuracy.",
          ],
        },
        {
          title: "External Links And Conduct",
          paragraphs: [
            "External links on CryptoBag may point to news providers, source websites, or other third-party destinations that are governed by their own terms and policies.",
            "Users should not attempt to misuse the site, disrupt its operation, or use it in a way that is unlawful or harmful.",
          ],
        },
      ]}
    />
  );
}
